module.exports = __webpack_public_path__ + "img/clouds.deb2da7b.png";